<template>
	<div class="manage-booking-search-banner">
		<div class="container">
			<h3>Manage Your Booking</h3>
			<div class="row">
				<div class="col-md">
					<div class="input-group icon-prepend" :class="{'has-danger': error.manageBookingEmail}">
						<input
							type="email"
							id="email"
							class="form-control"
							placeholder="Email address"
							:class="{'is-invalid': error.manageBookingEmail}"
							v-model="email"
							v-on:keyup.enter="findOrder()">
						<span class="input-group-prepend">
							<i class="fa fa-envelope"></i>
						</span>
						<div class="form-text text-red" v-if="error.manageBookingEmail">Your email address is missing</div>
					</div>
				</div>
				<div class="col-md">
					<div class="input-group icon-prepend" :class="{'has-danger': error.manageBookingOrderRef}">
						<input
							type="text"
							id="reference"
							class="form-control"
							placeholder="Order reference"
							:class="{'is-invalid': error.manageBookingOrderRef}"
							v-model="orderRef"
							v-on:keyup.enter="findOrder()">
						<span
							class="input-group-prepend"
							v-b-popover.hover.top="'When you placed an order with us, you will have received a booking confirmation email, which contains your order reference.'"
							title="Where do I find my order reference?"
						>
							<i class="far fa-info-circle"></i>
						</span>
						<div class="form-text text-red" v-if="error.manageBookingOrderRef">Your order reference is missing</div>
					</div>
				</div>
				<div class="col-md-auto">
					<button class="btn continue-btn btn-lg" @click="findOrder()">Find order</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	data() {
		return {
			email: null,
			error: {
				manageBookingEmail: false,
				manageBookingOrderRef: false
			},
			orderRef: null
		}
	},

	mounted() {
		this.resetErrors();
	},

	methods: {
		/** Find the order **/
		findOrder() {
			this.resetErrors();

			if (!this.email) {
				this.error.manageBookingEmail = true;
			}

			if (!this.orderRef) {
				this.error.manageBookingOrderRef = true;
			}

			if (this.email && this.orderRef) {
				this.resetErrors();

				window.location.href = `/manage/booking?order_ref=${this.orderRef}&email=${this.email}`;
			}
		},

		/** Reset all errors **/
		resetErrors() {
			this.error.manageBookingEmail = false;
			this.error.manageBookingOrderRef = false;
		},
	}
}
</script>

<style scoped>

</style>
